import {useSelector} from 'react-redux';
import {Breadcrumb} from '~/GalleryPB/components/Breadcrumb';
import {
  selectGalleryDataBreadcrumbs,
  selectGalleryDataPageDisplayName,
} from '~/GalleryPB/reducers/galleryData';
import {showSeoHeader} from '~/GalleryPB/utils';
import {Typography} from '~library/atoms/Typography';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';
import * as styles from './SeoHeaderWithBreadcrumb.module.scss';

export const SeoHeaderWithBreadcrumb = () => {
  const isLargishAndUp = useIsLargishAndUp();
  const breadcrumbs = useSelector(selectGalleryDataBreadcrumbs);
  const pageDisplayName = useSelector(selectGalleryDataPageDisplayName);

  const seoDataObj = window.top_of_page_copy;

  if (!showSeoHeader) return null;

  return (
    <div className={styles.wrapper} id="seo-header-with-breadcrumb">
      {!isLargishAndUp && <Breadcrumb path={breadcrumbs} className={styles.breadcrumbs} />}
      <div className={styles.content}>
        {isLargishAndUp && <Breadcrumb path={breadcrumbs} className={styles.breadcrumbs} />}
        <div className={styles.copyWrapper}>
          <Typography
            variant={isLargishAndUp ? 'header3' : 'header4'}
            as="h1"
            data-qa-id="galleryPageTitle"
          >
            {pageDisplayName}
          </Typography>
          <Typography
            variant={isLargishAndUp ? 'paragraph2' : 'paragraph3'}
            data-qa-id="gallerySeoHeaderMetadata"
          >
            {seoDataObj}
          </Typography>
        </div>
      </div>
    </div>
  );
};
